import { gql } from '@apollo/client';

export const ADDRESS_UPDATE = gql`
    mutation patchAddress( $input: PatchAddressInput! ) {
        patchAddress( input: $input ) {
            id
            companyId
            label
            name
            addressLine1
            addressLine2
            locality
            administrativeArea
            postalCode
            country{
                id
                code
                name
            }
            comment
            createdAt
            updatedAt
        }
    }
`;

export default ADDRESS_UPDATE;
